import React from 'react';
import { NavigationLink } from '.';
import { PropTypes } from 'prop-types';

export const UserIcon = ( { image, properties } ) => !image || !properties ? null :
  <NavigationLink className="box tab col-1 user" label={ properties.DisplayName } image={ image } resizeWidth="16px" />;

UserIcon.propTypes = {
  image: PropTypes.string.isRequired,
  properties: PropTypes.shape( {
    DisplayName: PropTypes.string.isRequired
  } )
};